/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const recordAttributionV2BodySchema = z.object({
  touchKind: z.enum(['first', 'last', 'event']),
  source: z.string().nullable(),
  medium: z.string().nullable(),
  campaign: z.string().nullable(),
  term: z.string().nullable(),
  content: z.string().nullable(),
  referrer: z.string().nullable(),
  gclid: z.string().nullable(),
  fbclid: z.string().nullable(),
  ttclid: z.string().nullable(),
  msclkid: z.string().nullable(),
  rawUrl: z.string().nullable(),
  referrerUserId: z.string().nullable(),
  capturedAt: z.number(),
});

export type IRecordAttributionV2Body = z.infer<typeof recordAttributionV2BodySchema>;
